import { createSelector } from 'reselect'
import viewTypes from 'helpers/enums/viewTypes'
import lessonTypes from 'helpers/enums/lessonTypes'

const getUrlParams = state => state.qs
const getStorePage = state => state.store.page
const getCurrentView = state => state.ui.currentView

const viewsToLessonTypeFilters = {
	[viewTypes.VIDEO_CREATE]: [lessonTypes.VIDEO],
	[viewTypes.INTERACTIVE_VIDEO_CREATE]: [lessonTypes.VIDEO],
	[viewTypes.VIDEO_STANDALONE_CREATE]: [lessonTypes.VIDEO],
	[viewTypes.TIME_TO_CLIMB_CREATION]: [lessonTypes.TIME_TO_CLIMB],
	[viewTypes.TIME_TO_CLIMB_STANDALONE_CREATION]: [lessonTypes.TIME_TO_CLIMB],
	[viewTypes.DRAW_IT_CREATION]: [lessonTypes.DRAW_IT],
	[viewTypes.DRAW_IT_STANDALONE_CREATION]: [lessonTypes.DRAW_IT],
	[viewTypes.MATCHING_PAIRS_CREATION]: [lessonTypes.MATCHING_PAIRS],
	[viewTypes.MATCHING_PAIRS_STANDALONE_CREATION]: [lessonTypes.MATCHING_PAIRS],
}

const getLessonTypeFilter = (currentView, urlParams) =>
	viewsToLessonTypeFilters[currentView] || urlParams.t

const storeSearchFormSelector = createSelector(
	[ getUrlParams, getStorePage, getCurrentView ],
	(urlParams, storePage, currentView) => {
		const lessonTypeFilter = getLessonTypeFilter(currentView, urlParams)
		return {
			query: urlParams.q,
			filters: urlParams.filters,
			page: storePage,
			lessonTypeFilter,
		}
	}
)

export default storeSearchFormSelector
